import { Posting } from './posting.model';
import * as momentImported from 'moment';
import { IPostingType } from '../interfaces/interfaces/posting-type.query.interface';
import { PostingImageCommand } from './posting-image.command.model';
import { IMaxbrainImageQuery } from 'app/library/image-library/interfaces/maxbrain-image.interface';
const moment = momentImported;

/**
 * Transform Posting model to Posting Json for the API
 */
export class PostingCommand {
    public posting_type: IPostingType;
    public language: string;
    public valid_from: string;
    public valid_to: string;
    public url: string;
    public image: IMaxbrainImageQuery;
    public title: string;
    public description: string;

    constructor(tempPosting: Posting) {
        if (tempPosting) {
            this.posting_type = {
                id: tempPosting.postingType.id,
                name: tempPosting.postingType.name,
                display_name_key_singular: null,
                display_name_key_plural: null,
                action_button_text_key: null,
                enabled_for: null,
            };

            this.url = tempPosting.url ? tempPosting.url : null;
            this.title = tempPosting.translations[0].title;
            this.description = tempPosting.translations[0].description;
            this.language = tempPosting.translations[0].language;

            if (tempPosting.image) {
                this.image = new PostingImageCommand(tempPosting);
            }

            if (tempPosting.validFrom) {
                this.valid_from = moment(tempPosting.validFrom).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
            }

            if (tempPosting.validTo) {
                this.valid_to = moment(tempPosting.validTo).endOf('day').format('YYYY-MM-DDTHH:mm:ss');
            }
        }
    }
}
